import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import mine from "../images/anmol.jpg";
import { FaGithub } from 'react-icons/fa';

function Aboutme() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 relative">
      {/* GitHub Profile Button */}
      <div className="flex justify-center mb-8 animate-slideUp">
        <a href="https://github.com/Anmolgaur7" target="_blank" rel="noopener noreferrer">
          <button className="group relative px-6 py-3 rounded-full bg-gradient-to-r from-accent-purple to-accent-cyan text-white text-lg font-semibold overflow-hidden transition-all duration-300 hover:shadow-glow-lg hover:scale-105">
            <span className="relative z-10 flex items-center gap-2">
              <FaGithub className="text-2xl" />
              Github Profile
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-accent-cyan to-accent-pink opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </a>
      </div>

      {/* Main Content Container with Glassmorphism */}
      <div className="glass-card max-w-4xl w-full animate-fadeIn">
        <div className="flex flex-col items-center">
          {/* Profile Image with Gradient Border */}
          <div className="relative group mb-6 animate-float">
            <div className="absolute -inset-1 bg-gradient-to-r from-accent-purple via-accent-cyan to-accent-pink rounded-full blur-lg opacity-75 group-hover:opacity-100 transition duration-300 animate-pulse-slow"></div>
            <img
              src={mine}
              className="relative w-40 h-40 md:w-56 md:h-56 lg:w-64 lg:h-64 rounded-full object-contain bg-gray-900 border-4 border-white/10 group-hover:scale-105 transition-transform duration-300"
              alt="Anmol Gaur"
            />
          </div>

          {/* Name and Title */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-white via-accent-cyan to-white bg-clip-text text-transparent">
              Hi, I am Anmol Gaur
            </h1>
            
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-white/90">
              I am a{' '}
              <TypeAnimation
                sequence={[
                  'Web Developer',
                  1000,
                  'Programmer',
                  1000,
                  'Android Developer',
                  1000,
                ]}
                wrapper="span"
                speed={10}
                className="gradient-text font-bold"
                repeat={Infinity}
              />
            </h2>

            {/* Bio */}
            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-3xl px-4 mt-6">
              Hey there, I'm a BCA student cruising through my 4th semester. My heart has taken a liking to React and the MERN stack - there's something captivating about weaving code into interactive experiences.
              As I tread the digital path, I've also dipped my toes into Android development, curious about the world of mobile apps.
              Join me in this tech journey as I blend creativity with coding, turning ideas into digital realities. Explore my portfolio and let's connect to bring innovation to life!
            </p>
          </div>

          {/* Resume Button */}
          <a 
            href="https://drive.google.com/file/d/1Om3fyh77SsrbACI17AGJFxX1fxC1uIii/view?usp=sharing" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mt-8"
          >
            <button className="group relative px-8 py-3 rounded-lg bg-gradient-to-r from-accent-pink to-accent-purple text-white text-xl font-bold overflow-hidden transition-all duration-300 hover:shadow-glow-lg hover:scale-105">
              <span className="relative z-10">Check Resume</span>
              <div className="absolute inset-0 bg-gradient-to-r from-accent-purple to-accent-cyan opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Aboutme;
